import React from "react";
import "./EducationalSources.css";
import { NdliLogoLibrary } from "../../../assets/exports/FileExports";
import {
  educational_sources_libraries,
  educational_sources_videos,
} from "../../../config/constants";
import SourceCard from "../../../theme/sourceCard/SourceCard";

const EducationalSources = () => {
  return (
    <div className="container educational-sources-container">
      <h3 className="educational-sources-section-name">Educational Sources</h3>
      <div className="sources-flex">
        <div className="source-container">
          <p className="paragraph-title source-title">E-Libraries</p>
          <div className="source-list inner-container-first">
            <ul className="source-scrollable-inner">
              {/* to avoid scrollbar spilling out of border radius of container */}
              {educational_sources_libraries.map((source, index) => (
                <li key={index} className="source-list-item">
                  <SourceCard
                    logo={source.logo}
                    heading={source.heading}
                    about={source.about}
                    link={source.link}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="source-container">
          <p className="paragraph-title elibraries-source-title">
            Video Sources
          </p>
          <div className="source-list inner-container-first ">
            <ul className="source-scrollable-inner">
              {/* to avoid scrollbar spilling out of border radius of container */}
              {educational_sources_videos.map((source, index) => (
                <li key={index} className="source-list-item">
                  <SourceCard
                    heading={source.heading}
                    about={source.about}
                    link={source.link}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EducationalSources;
